const SvgBellIcon = () => {
    return (
      <>
      <div className="jdTag_immediate jdTag active mt-4 text-orange-400">
     <svg
                        className="h-3 w-3 inline-block mr-1 "
                        fill="orange"
                        stroke="orange"
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448.01 512"
                      >
                        <defs>
                          <style>.cls-1{"fill:orange;"}</style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M224,0a32,32,0,0,0-32,32V51.2A160.07,160.07,0,0,0,64,208v18.8A192.46,192.46,0,0,1,15.5,354.4l-7.4,8.3A32,32,0,0,0,32,416H416a32,32,0,0,0,23.9-53.3l-7.4-8.3A192.27,192.27,0,0,1,384,226.8V208A160.07,160.07,0,0,0,256,51.2V32A32,32,0,0,0,224,0Zm45.3,493.3A64,64,0,0,0,288,448H160a64.06,64.06,0,0,0,109.3,45.3Z"
                          transform="translate(-0.02)"
                        />
                      </svg>
                      <strong className="text-orange font-assistant">
                        Immediately hiring
                      </strong>
                    </div>
      </>
    );
  };
  export default SvgBellIcon;